import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import LongRangeMoversWrapper from "@components/layouts/longrangemoversWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function TermsAndConditionsHome(): ReactElement {
    return (
        <LongRangeMoversWrapper>
            <section className="max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Moving"
                    domain="LongRangeMovers.com"
                />
            </section>
        </LongRangeMoversWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
